import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageWrapper from '../../components/PageWrapper';
import ClientLogin from '../../components/ClientLogin';
import ClientRegister from '../../components/ClientRegister';
import ClientDashboard from '../../bdcoreCandidates/ClientDashboard';
import InsideHeader from '../../components/InsideHeader';

function MyAccount({ builder, user, match, page }) {
  const product = get(match, 'params.product');

  return (
    <PageWrapper>
      <InsideHeader page={page} />
      {
        !user &&
        <div className="container py-5">
          <div className="row">
            <div className="col-md-6">
              <ClientLogin />
            </div>
            <div className="col-md-6">
              <ClientRegister />
            </div>
          </div>
        </div>
      }
      {
        user &&
        <ClientDashboard user={user} product={product} builder={builder} />
      }
    </PageWrapper>
  );
}

MyAccount.propTypes = {
  builder: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  user: PropTypes.object,
  page: PropTypes.object.isRequired,
};

MyAccount.defaultProps = {
  user: undefined,
};

export default withData(
  {
    match: true,
    user: true,
    page: 'my_account',
    builder: true,
  },
  {
    required: {
      page: true,
    },
  },
)(MyAccount);



// WEBPACK FOOTER //
// ./src/pages/MyAccount/index.js